module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-settings-v/tax-forms/1099-forms/1099-forms.component.scss
// module id = ./src/app/pages/vendor/my-settings-v/tax-forms/1099-forms/1099-forms.component.scss
// module chunks = main